import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PeopleFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="peopleFilled" ref={ref} {...props}>
      <path d="M4.38,8.93A3.66,3.66,0,1,1,8,12.63,3.66,3.66,0,0,1,4.38,8.93Zm6,5.55H5.63A4.53,4.53,0,0,0,1.1,19a.75.75,0,0,0,.75.74H14.17a.75.75,0,0,0,.75-.74A4.54,4.54,0,0,0,10.39,14.48Zm6.46-1.85A3.66,3.66,0,0,0,20.51,9V9a3.66,3.66,0,1,0-3.66,3.66ZM18,14.47H16.17a.55.55,0,0,0-.62.49,1.44,1.44,0,0,0,.36.95,12.09,12.09,0,0,1,.7,1.2A12.53,12.53,0,0,1,17.42,19c.15.46.33.75.75.75h3.61a.74.74,0,0,0,.74-.74A4.53,4.53,0,0,0,18,14.47Z" />
    </Icon>
  ),
) as IconWithRender;

PeopleFilledIcon.displayName = 'PeopleFilledIcon';
PeopleFilledIcon.renderIcon = (props) => <PeopleFilledIcon {...props} />;
export default PeopleFilledIcon;
